<template>
<v-container>
    <UserManager v-model="users"/>
    <ServiceManager :users="users" />
    <ContractManager />
</v-container>
</template>
<script>
import ContractRequest from '@/components/ContractRequest.vue';
import ContractResolver from '@/components/ContractResolver.vue';
import UserManager from '@/components/UserManager.vue';
import ServiceManager from '@/components/ServiceManager.vue';
import ContractManager from '@/components/ContractManager.vue';

export default {
    name: "AdminView",
    components: { ContractRequest, ContractResolver, ServiceManager, UserManager, ContractManager },
    data() {
        return {
            users: {},
        }
    },
    created() {
        if ('ADMIN' != localStorage.getItem('_session_role_')) {
            this.$router.replace('/')
        }
    }
}
</script>